import { z } from "zod";

const schema = z.object({
  retainerDaily: z.string().optional(),
  retainerHourly: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidatePricingFormSchema,
  type Schema as CandidatePricingFormSchema,
};
